import { useEffect, useState } from "react";
import { createPortal } from "react-dom";
import { useDispatch, useSelector } from "react-redux";
import styled from "styled-components";
import { ConfirmationModal } from "../../../../../components/organisms/Modal/confirmationModal";
import { useNotification } from "../../../../../hooks/useNotification";
import {
  useDeleteFilterCriteriaWithoutToastMutation,
  useDeleteViewMutation,
} from "../../../../../store/apiSlice/newInterfaceApiSlice";
import { setCurrentViewInLocals } from "../../../../../store/slice/newInterfaceSlice";
import { Down } from "../../../assets/svgIcon/listView/Down";
import { ReactComponent as UpIcon } from "../../../assets/svgIcon/listView/UpBlue.svg";
import { ReactComponent as Check } from "../../../assets/svgIcon/listView/check.svg";
import { ReactComponent as DeleteIcon } from "../../../assets/svgIcon/shipment/DeleteOutlined.svg";
import { ReactComponent as EditIcon } from "../../../assets/svgIcon/shipment/Edit.svg";
import { GeneralModal } from "../../../components/GeneralModal/GeneralModal";
import { PopupModal } from "../../../components/TopBar/PopupModal/PopupModal";
import { ToolTip } from "../../ToolTip/ToolTip";
import { moduleForView, selectState } from "../../utils/tableDataElements";

const isSimpleDataSelect = data => (data?.length ?? 0) > 0;

const ViewListItem = ({ name, isSelected, onSelect, onEdit, onDelete }) => (
  <div className="listItem" onClick={onSelect} role="button" tabIndex={0}>
    <span className="itemName">
      <span className="itemLabel">{name}</span>
    </span>
    <div className="iconGroup">
      {isSelected && <Check className="selectedCheck" aria-hidden />}
      {onEdit && (
        <button type="button" className="iconWrapper" aria-label={`Edit ${name}`} onClick={onEdit}>
          <EditIcon />
        </button>
      )}
      {onDelete && (
        <button
          type="button"
          className="iconWrapper delete"
          aria-label={`Delete ${name}`}
          onClick={onDelete}
        >
          <DeleteIcon />
        </button>
      )}
    </div>
  </div>
);

export function SelectComponent({
  title,
  boardView,
  setBoardView,
  data,
  LeftIcon,
  setIsOpenCreateView,
  selectedCurrentView,
  setSelectedCurrentView,
  orderType,
  allocation,
  forRow,
}) {
  const notify = useNotification();
  const {
    boardView: boardViewFromRedux,
    listView: { nameOfViews: listOfViewsForTable },
    completeListOfViews = [],
  } = useSelector(state => {
    if (orderType === "allocation") {
      return state["newTransferOrder"]["allocation"][allocation];
    }
    if (
      orderType === "inventory" ||
      orderType === "inventoryDetail" ||
      orderType === "inventoryTransactions"
    ) {
      return state.newWarehouse.inventory[orderType];
    }
    if (orderType === "receipt") {
      return state.receipt.receiptsLayout;
    }
    if (orderType === "product") {
      return state.product.productsLayout;
    }
    if (orderType === "productCategory") {
      return state.product.productCategoryLayout;
    }
    if (orderType === "productTag") {
      return state.product.productTagLayout;
    }
    if (orderType === "productAlias") {
      return state.product.productAliasLayout;
    }
    if (orderType === "productPlan") {
      return state.product.productPlanLayout;
    }
    if (orderType === "warehouse") {
      return state.supplier.warehouseLayout;
    }
    if (orderType === "supplier") {
      return state.supplier.supplierLayout;
    }
    if (orderType === "customer") {
      return state.customer.customerLayout;
    }
    if (orderType === "customerTag") {
      return state.customer.customerTagLayout;
    }
    if (orderType === "customerSegment") {
      return state.customer.customerSegmentLayout;
    }
    if (orderType === "pack") {
      return state.product.packLayout;
    }
    if (orderType === "stockPack") {
      return state.newWarehouse.stockPackLayout;
    }
    if (orderType === "warehouseCostingRange") {
      return state.newWarehouse.warehouseCostingRangeLayout;
    }
    if (orderType === "stockZone") {
      return state.newWarehouse.stockZoneLayout;
    }
    if (orderType === "forecast") {
      return state.newWarehouse.forecastLayout;
    }
    if (orderType === "warehouseCosting") {
      return state.newWarehouse.warehouseCostingLayout;
    }
    if (orderType === "stockLocation") {
      return state.newWarehouse.stockLocationLayout;
    }
    if (orderType === "transactionReason") {
      return state.report.transactionReasonLayout;
    }
    if (orderType === "standardCost") {
      return state.newWarehouse.standardCostLayout;
    }
    if (orderType === "taxRate") {
      return state.tax.taxRateLayout;
    }
    if (orderType === "site") {
      return state.newWarehouse.siteLayout;
    }
    if (orderType === "workCenter") {
      return state.newWarehouse.workCenterLayout;
    }
    if (orderType === "people") {
      return state.production.peopleLayout;
    }
    if (orderType === "users") {
      return state.user.usersLayout;
    }
    if (orderType === "boms") {
      return state.production.bomsLayout;
    }
    if (orderType === "manufacturingOrder") {
      return state.production.manufacturingOrderLayout;
    }
    if (orderType === "taxCategory") {
      return state.tax.taxCategoryLayout;
    }
    if (orderType === "productTaxClassification") {
      return state.tax.productTaxClassificationLayout;
    }
    if (orderType === "chartsOfAccount") {
      return state.account.chartsAccountLayout;
    }
    if (orderType === "paymentTerm") {
      return state.account.paymentTermsLayout;
    }
    if (orderType === "journalLine") {
      return state.account.journalLineLayout;
    }
    if (orderType === "bill") {
      return state.invoice.billLayout;
    }
    if (orderType === "saleInvoice") {
      return state.invoice.saleInvoiceLayout;
    }
    if (orderType === "receiptAdjustment") {
      return state.receipt.receiptAdjustmentLayout;
    }
    if (orderType === "syncHistory") {
      return state.integration.syncHistoryLayout;
    }
    if (orderType === "supplierCreditNote") {
      return state.invoice.supplierCreditNoteLayout;
    }
    if (orderType === "customerCreditNote") {
      return state.invoice.customerCreditNoteLayout;
    }
    if (orderType === "prePayment") {
      return state.invoice.prePaymentLayout;
    }
    if (orderType === "stockReplenishment") {
      return state.newWarehouse.stockReplenishmentLayout;
    }
    if (orderType === "plannedOrder") {
      return state.planner.plannedOrdersLayout;
    }
    if (orderType === "picklist") {
      return state.newWarehouse.picklistLayout;
    }
    if (orderType === "unitOfMeasure") {
      return state.unitOfMeasure.unitOfMeasureLayout;
    }
    if (orderType === "equipmentType") {
      return state.shipment.equipmentTypeLayout;
    }
    if (orderType === "equipment") {
      return state.shipment.equipmentLayout;
    }
    if (orderType === "salesRep") {
      return state.sales.salesRepLayout;
    }
    if (orderType === "salesOrder") {
      return state.sales.salesOrderLayout;
    }
    if (orderType === "customerReturn") {
      return state.sales.customerReturnLayout;
    }
    if (orderType === "pricelist") {
      return state.pricing.pricelistLayout;
    }
    if (orderType === "promo") {
      return state.promo.promoLayout;
    }
    if (orderType === "quote") {
      return state.sales.quoteLayout;
    }
    if (orderType === "delivery") {
      return state.shipment.deliveryLayout;
    }
    if (orderType === "shipmentV1") {
      return state.shipment.shipmentsV1Layout;
    }
    if (orderType === "asn") {
      return state.shipment.asnLayout;
    }
    if (orderType === "shipmentLeg") {
      return state.shipment.shipmentLegsLayout;
    }
    if (orderType === "shopifyCatalogue") {
      return state.integration.shopifyCatalogueLayout;
    }
    if (orderType === "shopifyLinkedProducts") {
      return state.integration.shopifyLinkedProductsLayout;
    }
    if (orderType === "shopifyStores") {
      return state.integration.shopifyStoresLayout;
    }
    if (orderType === "coManufacturingOrder") {
      return state.manufacturingOrder.coManufacturingOrderLayout;
    }
    if (orderType === "billChargeType") {
      return state.invoice.billChargeTypeLayout;
    }

    return (
      state[selectState[orderType]]?.allViews || {
        listView: { nameOfViews: [] },
        boardView: {
          status: { nameOfViews: [] },
          milestone: { nameOfViews: [] },
          combined: { nameOfViews: [] },
        },
      }
    );
  });

  const listOfViewForStatus = boardViewFromRedux?.status?.nameOfViews ?? [];
  const listOfViewForMilestone = boardViewFromRedux?.milestone?.nameOfViews ?? [];
  const listOfViewForCombined = boardViewFromRedux?.combined?.nameOfViews ?? [];

  const [isOpenSelect, setIsOpenSelect] = useState(false);
  const [selectedValue, setSelectedValue] = useState("");
  const [isOpenDeleteModal, setIsOpenDeleteModal] = useState(false);
  const [deleteData, setDeleteData] = useState(null);
  const [showViewNameOnHover, setShowViewNameOnHover] = useState(null);
  const [deleteFilterCriteria, { isLoading: deleteFilterCriteriaLoading }] =
    useDeleteFilterCriteriaWithoutToastMutation();
  const [deleteView, { isLoading: deleteLoading }] = useDeleteViewMutation();
  const dispatch = useDispatch();

  const closeModal = () => setIsOpenSelect(false);
  const openModal = () => setIsOpenSelect(true);

  const handleOnMouseOverOnHeaderView = item => {
    if (item.length > 17) {
      setShowViewNameOnHover(item);
    }
  };
  const resetOnMouseLeave = () => {
    setShowViewNameOnHover(null);
  };

  const closeDeleteModal = () => setIsOpenDeleteModal(false);
  const openDeleteModal = (e, id, name) => {
    e.stopPropagation();
    // Close the Views panel first — its overlay is z-index 1200 and would
    // cover ConfirmationModal (z-index ~11) if both stayed open.
    setIsOpenSelect(false);
    setDeleteData({ id, name });
    setIsOpenDeleteModal(true);
  };

  const handleDeleteModal = async () => {
    try {
      const findCurrentView = completeListOfViews?.find(item => item.id === deleteData.id);
      const criteriaId = findCurrentView?.filter_criteria?.id;
      if (criteriaId) {
        try {
          await deleteFilterCriteria(criteriaId).unwrap();
        } catch (criteriaError) {
          if (criteriaError?.status !== 404) throw criteriaError; // Rethrow if it's not a 404 error
        }
      }
      await deleteView(deleteData.id).unwrap();

      if (selectedCurrentView?.id === deleteData.id) {
        const defaultView = {
          value: "Default View",
          sub_type: null,
          id: null,
          is_view_rule_exists: false,
        };
        dispatch(
          setCurrentViewInLocals({
            view: defaultView,
            module: moduleForView[orderType],
            allocation,
          }),
        );
        setSelectedCurrentView(defaultView);
        setSelectedValue("Default View");
      }

      notify({
        type: "success",
        message: `View "${deleteData?.name}" successfully deleted—it's no longer in the list!`,
      });
    } catch (error) {
      notify({
        type: "error",
        message: error?.data?.detail || "Oops! Something went wrong while deleting the view.",
      });
    }
    closeDeleteModal();
  };

  const handleSelect = (value, id, is_view_rule_exists) => {
    const selectedView = {
      value: value,
      sub_type: boardView ? "status" : null,
      id: id,
      is_view_rule_exists,
    };
    dispatch(
      setCurrentViewInLocals({ view: selectedView, module: moduleForView[orderType], allocation }),
    );
    setSelectedCurrentView(selectedView);
    setSelectedValue(value);
    closeModal();
  };

  const handleSelectForStatus = (e, value, id, is_view_rule_exists) => {
    e.stopPropagation();

    const selectedView = { value: value, sub_type: "status", id: id, is_view_rule_exists };
    dispatch(setCurrentViewInLocals({ view: selectedView, module: moduleForView[orderType] }));
    setSelectedCurrentView(selectedView);
    setBoardView(true);
    setSelectedValue(value);
    closeModal();
  };

  const handleSelectForMilestone = (e, value, id, is_view_rule_exists) => {
    e.stopPropagation();
    const selectedView = { value: value, sub_type: "milestone", id: id, is_view_rule_exists };
    dispatch(setCurrentViewInLocals({ view: selectedView, module: moduleForView[orderType] }));
    setSelectedCurrentView(selectedView);
    setBoardView(true);
    setSelectedValue(value);
    closeModal();
  };

  const handleSelectForCombined = (e, value, id, is_view_rule_exists) => {
    e.stopPropagation();
    const selectedView = { value: value, sub_type: "combined", id: id, is_view_rule_exists };
    dispatch(setCurrentViewInLocals({ view: selectedView, module: moduleForView[orderType] }));
    setSelectedCurrentView(selectedView);
    setBoardView(true);
    setSelectedValue(value);
    closeModal();
  };

  const openCreateView = e => {
    e?.stopPropagation?.();
    setIsOpenCreateView({ isOpen: true, isEditMode: false });
    setIsOpenSelect(false);
  };

  const handleEditItem = (e, item, subType = null) => {
    e.stopPropagation();
    const selectedView = {
      value: item.name,
      sub_type: subType,
      id: item.id,
      is_view_rule_exists: item.is_view_rule_exists,
    };
    dispatch(
      setCurrentViewInLocals({ view: selectedView, module: moduleForView[orderType], allocation }),
    );
    setSelectedCurrentView(selectedView);
    setSelectedValue(item.name);
    if (
      (subType === "status" || subType === "milestone" || subType === "combined") &&
      setBoardView
    ) {
      setBoardView(true);
    }
    setIsOpenCreateView({ isOpen: true, isEditMode: true });
    setIsOpenSelect(false);
  };

  const isViewSelector = Boolean(setIsOpenCreateView) && !isSimpleDataSelect(data);

  useEffect(() => {
    if (selectedCurrentView?.value) {
      setSelectedValue(selectedCurrentView.value);
    }
  }, [selectedCurrentView]);

  const hasSavedViews =
    (listOfViewsForTable?.length ?? 0) > 0 ||
    (listOfViewForStatus?.length ?? 0) > 0 ||
    (listOfViewForMilestone?.length ?? 0) > 0 ||
    (listOfViewForCombined?.length ?? 0) > 0;

  const viewSelectorModal =
    isViewSelector &&
    isOpenSelect &&
    createPortal(
      <ViewSelectOverlay
        onMouseDown={event => {
          if (event.target === event.currentTarget) closeModal();
        }}
      >
        <GeneralModal
          titleOfModal="Views"
          closeModal={closeModal}
          widthOfGeneralModal="420px"
          classNameOfModal="milestoneModal viewSelectModal"
        >
          <ViewSelectPanel className="viewSelectPanel">
            <button type="button" className="addBtn" onClick={openCreateView}>
              <svg width="14" height="14" viewBox="0 0 14 14" aria-hidden="true">
                <path
                  d="M7 1.75v10.5M1.75 7h10.5"
                  stroke="currentColor"
                  strokeWidth="1.6"
                  strokeLinecap="round"
                />
              </svg>
              Create view
            </button>
            <div className="listOfCat">
              <ViewListItem
                name="Default View"
                isSelected={selectedValue === "Default View"}
                onSelect={() => handleSelect("Default View")}
              />
              {boardView ? (
                <>
                  {listOfViewForStatus?.length > 0 && (
                    <>
                      <p className="sectionLabel">Status views</p>
                      {listOfViewForStatus.map(item => (
                        <ViewListItem
                          key={item.id}
                          name={item.name}
                          isSelected={
                            selectedCurrentView?.id === item.id && selectedValue === item.name
                          }
                          onSelect={e =>
                            handleSelectForStatus(e, item.name, item.id, item.is_view_rule_exists)
                          }
                          onEdit={e => handleEditItem(e, item, "status")}
                          onDelete={e => openDeleteModal(e, item.id, item.name)}
                        />
                      ))}
                    </>
                  )}
                  {listOfViewForMilestone?.length > 0 && (
                    <>
                      <p className="sectionLabel">Milestone views</p>
                      {listOfViewForMilestone.map(item => (
                        <ViewListItem
                          key={item.id}
                          name={item.name}
                          isSelected={
                            selectedCurrentView?.id === item.id && selectedValue === item.name
                          }
                          onSelect={e =>
                            handleSelectForMilestone(
                              e,
                              item.name,
                              item.id,
                              item.is_view_rule_exists,
                            )
                          }
                          onEdit={e => handleEditItem(e, item, "milestone")}
                          onDelete={e => openDeleteModal(e, item.id, item.name)}
                        />
                      ))}
                    </>
                  )}
                  {(orderType === "shipment" || orderType === "purchase") &&
                    listOfViewForCombined?.length > 0 && (
                      <>
                        <p className="sectionLabel">Combined views</p>
                        {listOfViewForCombined.map(item => (
                          <ViewListItem
                            key={item.id}
                            name={item.name}
                            isSelected={
                              selectedCurrentView?.id === item.id && selectedValue === item.name
                            }
                            onSelect={e =>
                              handleSelectForCombined(
                                e,
                                item.name,
                                item.id,
                                item.is_view_rule_exists,
                              )
                            }
                            onEdit={e => handleEditItem(e, item, "combined")}
                            onDelete={e => openDeleteModal(e, item.id, item.name)}
                          />
                        ))}
                      </>
                    )}
                </>
              ) : (
                listOfViewsForTable?.map(item => (
                  <ViewListItem
                    key={item.id}
                    name={item.name}
                    isSelected={selectedCurrentView?.id === item.id && selectedValue === item.name}
                    onSelect={() => handleSelect(item.name, item.id, item.is_view_rule_exists)}
                    onEdit={e => handleEditItem(e, item)}
                    onDelete={e => openDeleteModal(e, item.id, item.name)}
                  />
                ))
              )}
            </div>
            {!hasSavedViews && <p className="empty">No saved views yet.</p>}
          </ViewSelectPanel>
        </GeneralModal>
      </ViewSelectOverlay>,
      document.getElementById("root-modals") || document.body,
    );

  const triggerClassName = isViewSelector
    ? isOpenSelect
      ? "milestoneBtn activeMilestone"
      : "milestoneBtn"
    : isOpenSelect
      ? "activeSelectTitle selectTitle"
      : "selectTitle";

  return (
    <div className="selectBox">
      <div
        className={triggerClassName}
        onClick={openModal}
        onMouseEnter={() => handleOnMouseOverOnHeaderView(title)}
        onMouseLeave={resetOnMouseLeave}
      >
        {!isViewSelector && LeftIcon && <LeftIcon color={isOpenSelect ? "#2060EA" : "#4A4A68"} />}
        {isViewSelector ? (
          <>
            {title.slice(0, 17)}
            {title.length > 17 && "..."}
          </>
        ) : (
          title
        )}
        {isOpenSelect ? <UpIcon /> : <Down />}
        {!isSimpleDataSelect(data) && showViewNameOnHover === title && (
          <ToolTip textOfTitle={title} />
        )}
      </div>

      {isOpenDeleteModal && (
        <ConfirmationModal
          titleOfModal="Delete Confirmation"
          btnName="Delete"
          handleModalWork={handleDeleteModal}
          closeModal={closeDeleteModal}
          description={`Think carefully! Deleting this "${deleteData.name}" view is permanent, and the data will be lost forever.`}
          labelForConfirmCheck="I understand that the data cannot be retrieved after deleting."
          isLoading={deleteFilterCriteriaLoading || deleteLoading}
        />
      )}

      {viewSelectorModal}

      {isOpenSelect && !isViewSelector && (
        <PopupModal closeModal={closeModal}>
          <div className={`optionsOfSelect ${forRow && forRow}`}>
            {data?.length > 0 &&
              data.map(item => (
                <div key={item} className="optionItem d-flex " onClick={() => handleSelect(item)}>
                  {item}
                  {selectedValue === item && <Check />}
                </div>
              ))}
          </div>
        </PopupModal>
      )}
    </div>
  );
}

const ViewSelectOverlay = styled.div`
  position: fixed;
  inset: 0;
  z-index: 1200;
  display: flex;
  align-items: center;
  justify-content: center;
  padding: 24px;
  background: rgba(16, 36, 77, 0.28);

  .milestoneModal {
    border-radius: 8px;
    box-shadow: 0 18px 48px rgba(16, 36, 77, 0.18);
  }

  .milestoneModal > .generalContent {
    display: flex;
    flex-direction: column;
    gap: 12px;
    padding: 16px;
  }

  .milestoneModal > h1 {
    border-radius: 8px 8px 0 0;
  }

  .milestoneModal > .createMilestone:not(:has(button)) {
    display: none;
  }
`;

const ViewSelectPanel = styled.div`
  display: flex;
  flex-direction: column;
  gap: 4px;

  > .addBtn {
    display: inline-flex;
    align-items: center;
    justify-content: center;
    gap: 8px;
    width: 100%;
    height: 36px;
    padding: 0 12px;
    border: 1px dashed #b7c8ef;
    border-radius: 6px;
    background: #f5f8ff;
    color: #1249bf;
    font-size: 13px;
    font-weight: 600;
    line-height: 20px;
    cursor: pointer;

    &:hover {
      background: #e8f0ff;
      border-color: #2060ea;
    }
  }

  > .listOfCat {
    display: flex;
    flex-direction: column;
    gap: 6px;
    max-height: 280px;
    margin-top: 4px;
    padding-right: 2px;
    overflow-y: auto;
  }

  .sectionLabel {
    margin: 8px 0 0;
    padding: 0 4px;
    color: #676879;
    font-size: 12px;
    font-weight: 600;
    line-height: 18px;
    text-transform: capitalize;
  }

  .listItem {
    display: flex;
    justify-content: space-between;
    align-items: center;
    min-width: 0;
    padding: 8px 8px 8px 12px;
    border: 1px solid transparent;
    border-radius: 6px;
    background: #f7f8f9;
    cursor: pointer;

    &:hover {
      border-color: #e5eaf0;
      background: #f3f6fb;
    }
  }

  .itemName {
    display: flex;
    align-items: center;
    gap: 8px;
    min-width: 0;
    color: #10244d;
  }

  .itemLabel {
    min-width: 0;
    overflow: hidden;
    text-overflow: ellipsis;
    white-space: nowrap;
    font-size: 13px;
    line-height: 20px;
  }

  .iconGroup {
    display: flex;
    flex: 0 0 auto;
    gap: 2px;
    align-items: center;
  }

  .selectedCheck {
    flex-shrink: 0;
  }

  .iconWrapper {
    display: inline-flex;
    align-items: center;
    justify-content: center;
    width: 28px;
    height: 28px;
    padding: 0;
    border: none;
    border-radius: 4px;
    background: transparent;
    cursor: pointer;

    svg path {
      fill: #4a4a68;
    }

    &:hover {
      background: #fff;
    }

    &.delete:hover svg path {
      fill: #cf324a;
    }
  }

  > .empty {
    margin: 2px 0 0;
    color: #676879;
    font-size: 13px;
    line-height: 20px;
  }
`;

export const styleOfModal = { position: "absolute", zIndex: 5 };

export const styleOfDeleteModal = {
  position: "absolute",
  zIndex: 5,
  margin: "auto",
  left: 0,
  backgroundColor: "white",
  right: 0,
  maxWidth: "max-content",
};
